import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { model: { type: String, default: "package" } }

  connect() {
    // Wait a bit for Slim Select to initialize, then setup fields
    setTimeout(() => {
      this.initializeFields()
    }, 100)
  }

  initializeFields() {
    // Get all key checkboxes
    const keyCheckboxes = this.element.querySelectorAll('input[type="checkbox"][name^="keys["]')
    
    keyCheckboxes.forEach(checkbox => {
      // Extract field name from checkbox name (e.g., "keys[name]" -> "name")
      const fieldName = checkbox.name.match(/keys\[(.+)\]/)?.[1]
      
      if (fieldName) {
        // Find the corresponding form field
        const formField = this.findFormField(fieldName)
        
        if (formField) {
          // Set initial state (including Slim Select wrappers)
          this.updateFieldState(formField, checkbox.checked)
          
          // Add event listener
          checkbox.addEventListener('change', () => {
            this.updateFieldState(formField, checkbox.checked)
          })
        }
      }
    })
  }

  findFormField(fieldName) {
    const model = this.modelValue
    // Try different selectors to find the form field
    const selectors = [
      `#${model}_${fieldName}`,           // Simple fields like #package_name
      `select[name="${model}[${fieldName}]"]`,  // Select fields
      `input[name="${model}[${fieldName}]"]`,   // Input fields
      `textarea[name="${model}[${fieldName}]"]`, // Textarea fields
      `select[name="${model}[${fieldName}][]"]`  // Multi-select fields
    ]

    for (const selector of selectors) {
      const field = this.element.querySelector(selector)
      if (field) return field
    }

    return null
  }

  updateFieldState(field, isEnabled) {
    if (isEnabled) {
      field.style.opacity = '1'
      field.disabled = false
      
      // Handle the Slim Select wrapper if it exists
      const slimSelectWrapper = field.closest('.ss-main')
      if (slimSelectWrapper) {
        slimSelectWrapper.style.opacity = '1'
        // Also remove pointer-events restriction
        slimSelectWrapper.style.pointerEvents = 'auto'
      }
    } else {
      field.style.opacity = '0.3'
      field.disabled = true
      
      // Handle the Slim Select wrapper if it exists  
      const slimSelectWrapper = field.closest('.ss-main')
      if (slimSelectWrapper) {
        slimSelectWrapper.style.opacity = '0.3'
        // Disable pointer events to prevent interaction
        slimSelectWrapper.style.pointerEvents = 'none'
      }
    }
  }
}